import Modal from 'services/modal';
import BaseService from 'services/base';

const PricingService = Object.assign(
  {
    save(config: any = {}, cb: Function = () => {}, dispatch: Function) {},

    //发布
    publish(postbody: any, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          apiPath: '/price/order/publish',
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认发布核价单？', ok, dispatch);
    },

    //作废
    abandon(postbody: any, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          apiPath: '/price/order/abandon',
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认作废核价单？', ok, dispatch);
    },

    //撤回
    recall(postbody: any, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          apiPath: '/price/order/revoke',
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('确认撤回核价单？', ok, dispatch);
    },

    //审核
    audit(postbody: any, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          apiPath: '/price/order/audit',
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('您是否确认此操作？', ok, dispatch);
    },

    //下行ERP
    handleERP(postbody: any, cb: Function = () => {}, dispatch: Function) {
      let ok = () => {
        let config = {
          ...postbody,
          apiPath: '/price/order/send2ERP',
          successMsg: '操作成功'
        };
        this.save(config, cb, dispatch);
      };
      Modal.showConfirm('您是否确认此操作？', ok, dispatch);
    }
  },
  BaseService
);

export default PricingService;
